import React, { useEffect } from 'react'

import ActivitySection from './ActivitySection'
import InvoiceSection from './InvoiceSection'
import StudentSection from './StudentSection'
import { useUser } from '../../../../context'

import { DashboardContainer } from './styles'

const Dashboard = () => {
  const { setOnEditionMode } = useUser()

  useEffect(() => {
    setOnEditionMode(false)
  }, [])
  return (
    <DashboardContainer>
      <StudentSection />
      <div className="act-inv-container">
        <ActivitySection />
        <InvoiceSection />
      </div>
    </DashboardContainer>
  )
}

export default Dashboard
